// extracted by mini-css-extract-plugin
export var scrollArea = "_qd-0";